import { useState, useEffect, useRef } from "react";

export function useAIChat({ gradeInfo, topic, currentProblem }) {
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isAILoading, setIsAILoading] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (chatEndRef.current) chatEndRef.current.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  const askAI = async () => {
    if (!chatInput.trim() || isAILoading) return;
    const userMsg = chatInput.trim();
    setChatInput("");
    setChatMessages(m => [...m, { role: "user", text: userMsg }]);
    setIsAILoading(true);

    try {
      const systemPrompt = `You are a friendly, encouraging math tutor for a ${gradeInfo?.label} student. Current topic: "${topic?.name}". Current problem: "${currentProblem?.q}" (answer is ${currentProblem?.a}).
      - Be warm, use simple language appropriate for the grade level
      - Guide with hints, don't just give the answer unless they're really stuck
      - Use emojis occasionally to be friendly
      - Keep responses concise (2-4 sentences max)
      - If they give a wrong approach, gently redirect`;

      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: 1000,
          system: systemPrompt,
          messages: [
            ...chatMessages
              .filter(m => m.role !== "system")
              .map(m => ({ role: m.role === "assistant" ? "assistant" : "user", content: m.text })),
            { role: "user", content: userMsg }
          ]
        })
      });
      const data = await res.json();
      const aiText = data.content?.[0]?.text || "I'm having trouble connecting. Try again!";
      setChatMessages(m => [...m, { role: "assistant", text: aiText }]);
    } catch {
      setChatMessages(m => [...m, { role: "assistant", text: "Oops! Connection issue. Try again in a moment 🔄" }]);
    }
    setIsAILoading(false);
  };

  return {
    chatMessages,
    setChatMessages,
    chatInput,
    setChatInput,
    isChatOpen,
    setIsChatOpen,
    isAILoading,
    askAI,
    chatEndRef,
  };
}
